import { render } from "./DropdownMenuItem.vue?vue&type=template&id=0f155c34&scoped=true"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=js"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=js"

import "./DropdownMenuItem.vue?vue&type=style&index=0&id=0f155c34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f155c34"]])

export default __exports__